import sparePartsApi, { ApiResponse } from "../../../../api/spareParts.api";

import {
  Category,
  CategoryFilters,
  CategoryListResponse,
  CategoryPayload,
  Pagination,
  RecordStatus,
} from "../types";

const BASE_URL = "/categories";

export const CategoryService = {
  async getCategories(params?: CategoryFilters): Promise<CategoryListResponse> {
    const response = await sparePartsApi.get<ApiResponse<Category[]>>(
      BASE_URL,
      { params }
    );

    return {
      data: response.data.data || [],
      pagination: response.data.meta as Pagination,
    };
  },

  async getCategory(id: string): Promise<Category> {
    const response = await sparePartsApi.get<ApiResponse<Category>>(
      `${BASE_URL}/${id}`
    );

    return response.data.data;
  },

  async createCategory(data: CategoryPayload): Promise<Category> {
    const response = await sparePartsApi.post<ApiResponse<Category>>(
      BASE_URL,
      data
    );

    return response.data.data;
  },

  async updateCategory(
    id: string,
    data: CategoryPayload
  ): Promise<Category> {
    const response = await sparePartsApi.put<ApiResponse<Category>>(
      `${BASE_URL}/${id}`,
      data
    );

    return response.data.data;
  },

  async updateStatus(
    id: string,
    status: RecordStatus
  ): Promise<Category> {
    const response = await sparePartsApi.patch<ApiResponse<Category>>(
      `${BASE_URL}/${id}/status`,
      { status }
    );

    return response.data.data;
  },

  async deleteCategory(id: string): Promise<void> {
    await sparePartsApi.delete(`${BASE_URL}/${id}`);
  },
};
